<app-input
  [label]="label"
  [placeholder]="placeholder"
  pattern="^[0-9]*$"
  [value]="stringValue"
  (valueChange)="onChange($event)">

</app-input>
